import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { nodeToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

/**
 * Defines nodes that are typically in the <head> of an HTML document.
 */
export class HeadSchemaPlugin extends SchemaPlugin {
  nodes = {
    base: {
      group: 'block',
      content: 'inline*',
      parseDOM: [{
        tag: 'base'
      }],
      toDOM(node) { return nodeToDOM(node); },
      editorTagName: 'mc-lwe-base',
      isTagNameBox: true,
      atom: true,
      isVoid: true,
      noStyles: true
    },

    meta: {
      group: 'inline',
      inline: true,
      parseDOM: [{
        tag: 'meta',
      }],
      toDOM(node) { return nodeToDOM(node); },
      editorTagName: 'mc-lwe-meta',
      isTagNameBox: true,
      isVoid: true,
      noStyles: true
    },

    resourceLink: {
      group: 'inline',
      inline: true,
      parseDOM: [{
        tag: 'link',
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'link',
      editorTagName: 'mc-lwe-link',
      isTagNameBox: true,
      isVoid: true,
      noStyles: true
    },

    style: {
      group: 'inline',
      inline: true,
      attrs: {
        content: { default: undefined, skipExport: true, skipEditorExport: true },
        blocking: { default: undefined },
        media: { default: undefined },
        nonce: { default: undefined },
        title: { default: undefined }
      },
      parseDOM: [{
        tag: 'style',
        preserveWhitespace: true,
        getAttrs: function (dom: HTMLElement) {
          return {
            ...getSchemaAttrs(dom, ['blocking', 'media', 'nonce', 'title']),
            content: dom.outerHTML
          };
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        return nodeToFlareXML(node, options, 'style', {
          xml: node.attrs.content
        });
      },
      editorTagName: 'mc-lwe-style',
      isTagNameBox: true,
      noStyles: true
    },

    title: {
      group: 'inline',
      content: 'inline*',
      inline: true,
      definingForContent: true,
      atom: true,
      parseDOM: [{
        tag: 'title',
        preserveWhitespace: true
      }],
      toDOM(node) {
        return nodeToDOM(node, {
          tagNameBoxTooltipContent: node.textContent ?? ''
        });
      },
      // Render as <mc-lwe-title> to avoid overriding the document title for the page
      editorTagName: 'mc-lwe-title',
      isTagNameBox: true,
      noStyles: true
    }
  } satisfies Record<string, NodeSpec>;
}
